import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import SortableColumn from './SortableColumn';
import * as sortableListActions from '../../../actions/common/sortableListActions';

class SortableHead extends React.Component{
    constructor(props) {
        super(props);
    }

    render() {
        let {
            listId,
            action,
            columns,
            actionParams
        } = this.props;

        return <thead>
            <tr>
                {columns.map(column => {
                    return <th key={listId+column.title} className={column.className}>
                        <SortableColumn
                            listId={listId}
                            action={action}
                            actionParams={actionParams}
                            title={column.title}
                            name={column.name}
                        />
                    </th>
                })}
            </tr>
        </thead>;
    }
}

function mapStateToProps(state, ownProps) {
    return {};
}


function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(
            Object.assign(
                {},
                sortableListActions
            ), dispatch)
    }

}

export default connect(mapStateToProps, mapDispatchToProps)(SortableHead);


// WEBPACK FOOTER //
// ./web/src/components/common/list/SortableHead.jsx